function showPreview(swatch) {
  const card = swatch.closest('.product-grid__item');
  const preview = card && card.querySelector('.card-colorway-strip__preview');
  if (!preview) return;
  preview.src = swatch.dataset.previewSrc;
  preview.srcset = swatch.dataset.previewSrcset || '';
  preview.classList.add('is-visible');
}

function hidePreview(swatch, relatedTarget) {
  const card = swatch.closest('.product-grid__item');
  if (!card || card.contains(relatedTarget)) return;
  const preview = card.querySelector('.card-colorway-strip__preview');
  if (preview) preview.classList.remove('is-visible');
}

document.addEventListener('mouseover', (event) => {
  const swatch = event.target.closest('.card-colorway-strip__swatch');
  if (swatch) showPreview(swatch);
});

document.addEventListener('mouseout', (event) => {
  const swatch = event.target.closest('.card-colorway-strip__swatch');
  if (swatch) hidePreview(swatch, event.relatedTarget);
});

document.addEventListener('focusin', (event) => {
  const swatch = event.target.closest('.card-colorway-strip__swatch');
  if (swatch) showPreview(swatch);
});

document.addEventListener('focusout', (event) => {
  const swatch = event.target.closest('.card-colorway-strip__swatch');
  if (swatch) hidePreview(swatch, event.relatedTarget);
});
